import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminUserManagementPage from "@/pages/admin/AdminUserManagementPage";

export const Route = createFileRoute("/_admin/admin/user-management")({
  head: () => pageHead("Admin · User Management", "AKIVA admin · user management portal.", "/admin/user-management", true),
  component: AdminUserManagementPage,
});
